<template>
  <div :bridgeData="bridgeData"></div>
</template>

<script>
import { projectBasePathWithFolder } from "../../config/apiEndpoints";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
import { keyMapsAction } from "../../helpers/storeKeys";
import setEvents, { loadAmplitudeUnsentEvents } from "../../helpers/events.js";
import Location from "../../config/location";

export default {
  name: "QrOrder",
  props: ["moduleProps"],
  data() {
    return {
      modulePropsData: {},
      token: null,
    };
  },
  mounted() {
    loadAmplitudeUnsentEvents();
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    const queryParams = new URLSearchParams(window.location.search);
    const storeId =
      queryParams.get("storeid") || queryParams.get("storeId") || Location.defaultStoreId;

    sessionStorage.setItem("qrOrder", true);
    sessionStorage.setItem(
      "qrOrderExpiry",
      (
        Date.now() + (Number(this.modulePropsData?.qrOrderExpiry) || 10800000)
      ).toString(),
    );

    this.$store.dispatch(keyMapsAction.CACHED_STORE_API, {
      storeId: storeId,
      qrOrderFlow: true,
    });
    this.eventFunction();
  },
  computed: {
    bridgeData() {
      const cachedStoreApiLoaded =
        this.$store.state.Location.cachedStoreApiLoaded;
      if (cachedStoreApiLoaded) {
        const remainingQuery = this.getRemainingQueryParams(
          window.location.href,
          ["storeid", "ordertype", "storeId", "orderType"],
        );
        window.location.href =
          projectBasePathWithFolder +
          Utility.getCurrentStoreFolder() +
          LocalStorageFunc.storeId() +
          remainingQuery;
      }
    },
  },
  methods: {
    getRemainingQueryParams(url, paramsToRemove = []) {
      const urlObj = new URL(url);

      paramsToRemove.forEach((param) => {
        urlObj.searchParams.delete(param);
      });

      return urlObj.search;
    },
    eventFunction(eventType = "") {
      const eObj = {
        userAction: "Impression",
        sectionName: "QR Order",
        screenName: "QR Order Page",
        Page_Name: "QR Order Page",
      };
      const eventObj = Utility.amplitudeEventObj(
        eObj.userAction,
        eObj.sectionName,
        undefined,
        eObj,
      );

      setEvents("amplitude", "Impression", eventObj);
    },
  },
};
</script>
